import type { JSONContent } from "@tiptap/react";
import { TipTapRender } from "./tip-tap-render";
import type { TipTapBaseNode, TipTapMarkHandlers, TipTapNodeHandlers, TipTapRenderHandlers } from "./interfaces";

const Heading = (props: { level: number; children: React.ReactNode }) => {
	switch (props.level) {
	  case 1:
		 return <h1 className="my-5 text-3xl font-bold">{props.children}</h1>;
	  case 2:
		 return <h2 className="my-5 text-xl font-bold">{props.children}</h2>;
	  case 3:
		 return <h3 className="my-5 text-lg font-bold">{props.children}</h3>;
	  default:
		 return <h4 className="my-5 text-base font-bold">{props.children}</h4>;
	}
 };
const markHandlers: TipTapMarkHandlers = {
	link: (props) => (
		<a href={props.node.attrs.href} target="_blank" rel="noreferrer">
			{props.children}
		</a>
	),
	bold: (props) => <b>{props.children}</b>,
	italic: (props) => <i>{props.children}</i>,
	underline: (props) => <u>{props.children}</u>,
	strike: (props) => <s>{props.children}</s>,
	code: (props) => <code>{props.children}</code>,
	h1: (props) => <>{props.children}</>,
	h2: (props) => <>{props.children}</>,
	h3: (props) => <>{props.children}</>,
	h4: (props) => <>{props.children}</>,
	textStyle: (props) => <>{props.children}</>,
};

const nodeHandlers: TipTapNodeHandlers = {
	doc: (props) => <>{props.children}</>,
	text: (props) => props.className ? <span className={props.className} style={props.style}>{props.node.text}</span> : <>{props.node.text}</>,
	paragraph: (props) => <p className={props.className}>{props.children}</p>,
	heading: (props) => <Heading level={+props.node.attrs.level}>{props.children}</Heading>,
	hardBreak: () => <br />,
	bulletList: (props) => <ul className="my-4 pl-10 list-disc">{props.children}</ul>,
	orderedList: (props) => <ol className="my-4 pl-10 list-decimal">{props.children}</ol>,
	listItem: (props) => <li>{props.children}</li>,
	codeBlock: (props) => (
		<pre>
			<code>{props.children}</code>
		</pre>
	),
	horizontalRule: () => <hr />,
	blockquote: (props) => <blockquote>{props.children}</blockquote>,
};
const handlers: TipTapRenderHandlers = {
	...markHandlers,
	...nodeHandlers,
};
export function TipTapWeb({ content, className }: { content: TipTapBaseNode | JSONContent, className?: string }) {
	return <div className={className} style={{wordWrap: "break-word", whiteSpace: "break-spaces", fontVariantLigatures: "none", fontFeatureSettings: "'liga' 0"}}>
		{content ? <TipTapRender node={content as TipTapBaseNode} handlers={handlers} /> : null}
	</div>
}